// Text-similarity helpers used by the duplicate detector and texture fallback matcher.

export function normalizeName(name: string): string {
  const ADJECTIVES = [
    'reinforced', 'strong', 'improved', 'enhanced', 'upgraded', 'greater', 'lesser',
    'super', 'mega', 'ultra', 'advanced', 'modified', 'custom', 'special', 'fine',
    'heavy', 'light', 'minor', 'major', 'prime', 'true', 'pure', 'perfect', 'basic',
    'sturdy', 'tough', 'hardened', 'tempered', 'blessed', 'cursed', 'royal', 'grand',
  ];
  const tokens = name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter((t) => t.length > 0 && !ADJECTIVES.includes(t));
  return tokens.sort().join(' ');
}

export function levenshtein(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const dp = new Array(n + 1);
  for (let j = 0; j <= n; j++) dp[j] = j;
  for (let i = 1; i <= m; i++) {
    let prev = dp[0];
    dp[0] = i;
    for (let j = 1; j <= n; j++) {
      const tmp = dp[j];
      dp[j] = Math.min(dp[j - 1] + 1, dp[j] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = tmp;
    }
  }
  return dp[n];
}

export function stringSimilarity(a: string, b: string): number {
  if (a === b) return 1;
  if (!a.length || !b.length) return 0;
  const dist = levenshtein(a, b);
  return 1 - dist / Math.max(a.length, b.length);
}

export function jaccard(a: string[], b: string[]): number {
  const sa = new Set(a);
  const sb = new Set(b);
  let inter = 0;
  for (const x of sa) if (sb.has(x)) inter++;
  const union = sa.size + sb.size - inter;
  return union === 0 ? 0 : inter / union;
}
